// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamListItemPortfolioSection-module--container--a29d99","image":"TeamListItemPortfolioSection-module--image--9c56c8"};